var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 18.666a3.983 3.983 0 0 0 3.986-4l.014-8c0-2.213-1.787-4-4-4s-4 1.787-4 4v8c0 2.213 1.787 4 4 4m7.067-4c0 4-3.387 6.8-7.067 6.8s-7.067-2.8-7.067-6.8H6.667c0 4.547 3.626 8.307 8 8.96v4.373h2.666v-4.373c4.374-.64 8-4.4 8-8.96z"
  })));
};
export default SvgMic;